/* eslint-disable */
import React, {useState} from 'react'
import {
    Row,
    Col,
    Button,
    InputGroup,
    FormControl,
    Spinner
} from "react-bootstrap";
import FormSelect from "../FormSelect";
import '../GuideSideBar.scss';

const MemorableMoment = (props) => {
    const { setMemorableMomentCount, memorableMomentCount, setSubFormType, showLoading, handleFormSubmit } = props
    const [formData, setFormData] = useState({type_id: 12})
    const [formErrors, setFormErrors] = useState()

    const validateForm = (formData) => {
        if (!formData.description.trim()) return "description"
        return null
    }

    const formChange = (field, value) => {
        setFormData({...formData, [field]: value})
        setFormErrors(null)
    }

    const submitForm = async (e) => {
        e.preventDefault();
        const hasErrors = validateForm(formData)
        if (hasErrors) {
            setFormErrors(hasErrors)
            return
        }
        handleFormSubmit(formData)
        setMemorableMomentCount(memorableMomentCount + 1)
        setFormData(null)
        setSubFormType(0)
    }
   
  return (
        <form onSubmit={submitForm}>
            <Row>
                <Col className="heading-label">
                    Add Memorable Moment
                </Col>
            </Row>
            
            <Row className="select-row">
                <Col className="meeting-col">
                    <div className="select-label">Description*</div>
                    {formErrors === "description" &&
                        <div className="invalid-feedback d-block">This field is required</div>
                    }
                    <InputGroup>
                        <FormControl required as="textarea" aria-label="With textarea"
                            onChange={e => formChange('description', e.target.value)}
                            value={formData.description}
                        />
                    </InputGroup>
                </Col>  
            </Row>

            <Row className="select-row last-row">
                <Col className="meeting-col">
                    <Button className={"cancel-form-btn"} onClick={() => setSubFormType(0)} variant="light">
                        Cancel
                    </Button>
                    <Button type="submit" className={"game-state-btn"} variant="light" disabled={showLoading}>
                        Submit {' '}
                        {showLoading && (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        )}
                    </Button>
                </Col>  
            </Row>

        </form>
  );
}

export default MemorableMoment
